import { Component, inject } from '@angular/core';
import {Vehicle} from '@app/vehicle/shared/vehicle';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {VatApi} from '@shared/api/vat.api';
import {Vat} from '@shared/objects/vat';
import {VehicleCalculate} from '@app/vehicle/shared/vehicle-calculate';
import {VehicleApi} from '@app/vehicle/shared/vehicle.api';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { DecimalPipe } from '@angular/common';

@Component({
    templateUrl: 'bpmcalc-dialog.component.html',
    styleUrls: ['bpmcalc-dialog.component.scss'],
    imports: [MatToolbar, MatIcon, MatIconButton, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton, DecimalPipe]
})
export class BpmcalcDialogComponent {
  dialogRef = inject<MatDialogRef<BpmcalcDialogComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);
  private vatApi = inject(VatApi);
  private vehicleApi = inject(VehicleApi);
  data = inject(MAT_DIALOG_DATA);

  vehicle: Vehicle;
  calcForm: UntypedFormGroup;
  result: VehicleCalculate = new VehicleCalculate();
  vatList: Vat[];

  constructor() {
    const data = this.data;

    this.vatApi.findAll().subscribe(value => {
      this.vatList = [];
      value
        .filter(value1 => value1.active && value1.invoiceLineDiscriminator.startsWith('V'))
        .forEach(value1 => this.vatList.push(value1));
    });

    this.vehicle = data.vehicle;
    this.calcForm = this.formBuilder.group({
      vrn: [],
      grossBpm: [],
      vatId: [],
      firstAdmissionDate: [],
      date: [],
      inclusive: []
    });

    if (this.vehicle) {
      this.calcForm.patchValue({
        vrn: this.vehicle.vrn,
        grossBpm: this.vehicle.grossBpm,
        firstAdmissionDate: this.vehicle.firstAdmissionDate,
        date: new Date()
      }, {emitEvent: false});
    }

    if (data.vatId) {
      this.calcForm.patchValue({
        vatId: data.vatId
      }, {emitEvent: false});
    }

  }

  onSubmit() {
    const vehicleCalculate = new VehicleCalculate();
    vehicleCalculate.vrn = this.calcForm.value.vrn;
    vehicleCalculate.grossBpm = this.calcForm.value.grossBpm;
    vehicleCalculate.vatId = this.calcForm.value.vatId;
    vehicleCalculate.firstAdmissionDate = this.calcForm.value.firstAdmissionDate;
    vehicleCalculate.date = this.calcForm.value.date;
    vehicleCalculate.inclusive = this.calcForm.value.inclusive;

    this.vehicleApi.calculate(vehicleCalculate).subscribe(value => {
      this.result = value;
    });
  }

}
